<template>
  <div class="container-fluid py-4">

    <!-- Header moderne -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-clinique flex-wrap">
      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-shield-lock fs-2 text-primary"></i>
        <h2 class="fw-bold mb-0">Rôles</h2>
      </div>
      <button class="btn btn-primary btn-lg shadow-sm btn-clinique mt-2 mt-md-0" @click="creation()" v-if="$store.getters.hasPermission('ADMIN_CREER_ROLE')">
        <i class="bi bi-plus-circle me-1"></i> 
      </button>
    </div>

    <!-- Filtres et recherche -->
    <div class="card p-3 mb-4 shadow-sm rounded card-clinique">
      <div class="row g-3 align-items-end">
        <div class="col-12 col-md-4">
          <label class="form-label fw-semibold">Rechercher</label>
          <input type="text" v-model="searchQuery" placeholder="Nom du rôle..." class="form-control form-control-clinique">
        </div>
        <div class="col-6 col-md-2">
          <label class="form-label fw-semibold">Items par page</label>
          <select v-model="itemsperpage" class="form-select form-select-clinique">
            <option v-for="item in itemsPerPageT" :key="item" :value="item">{{ item }}</option>
          </select>
        </div>
        <div class="col-6 col-md-3">
          <label class="form-label fw-semibold">Trier par</label>
          <select v-model="orderBy" class="form-select form-select-clinique">
            <option v-for="(value, key) in orderByTabs" :key="key" :value="value">{{ key }}</option>
          </select>
        </div>
        <div class="col-6 col-md-3">
          <label class="form-label fw-semibold">Ordre</label>
          <select v-model="sortOrder" class="form-select form-select-clinique">
            <option v-for="(value, key) in sortOrders" :key="key" :value="value">{{ key }}</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Loader -->
    <div v-if="isLoading" class="text-center my-5">
      <div class="spinner-border text-primary" role="status" style="width: 4rem; height: 4rem;"></div>
      <p class="mt-3">Chargement des rôles...</p>
    </div>

    <!-- Tableau moderne -->
    <div v-else class="card shadow-sm rounded card-clinique">
      <div class="table-responsive overflow-auto">
        <table class="table align-middle text-center mb-0 table-hover modern-table-clinique w-100">
          <thead>
            <tr>
              <th>#</th>
              <th>Nom</th>
            
              <th>Statut</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(type, index) in filteredTypeUsers" :key="type.id">
              <td>{{ index + 1 + (currentPage - 1) * itemsperpage }}</td>
              <td>{{ type.nom }}</td>
              <!--<td>
                <ul class="nav flex-column">
                  <li v-for="permission in type.permission" :key="permission.id" class="nav-item">{{ permission.nom }}</li>
                </ul>
              </td>-->
              <td>
                <span :class="type.isEnabled ? 'badge bg-success' : 'badge bg-secondary'">
                  {{ type.isEnabled ? 'Activé' : 'Désactivé' }}
                </span>
              </td>
              <td>
                <div class="dropdown">
                  <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown">
                    Actions
                  </button>
                  <ul class="dropdown-menu">
                    <li v-if="$store.getters.hasPermission('ADMIN_MODIFIER_ROLE')"><a class="dropdown-item" @click="modifier(type.id)">Modifier</a></li>
                    <li v-if="$store.getters.hasPermission('ADMIN_SUPPRESSION_ROLE')"><a class="dropdown-item text-danger" @click="supprimer(type.id)">Supprimer</a></li>
                  </ul>
                </div>
              </td>
            </tr>
            <tr v-if="typeUsers.length === 0">
              <td colspan="5" class="text-center py-3">Aucune donnée disponible</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="d-flex justify-content-end p-3">
        <ul class="pagination pagination-modern flex-wrap mb-0">
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <button class="page-link" @click="changePage(currentPage - 1)">Précédent</button>
          </li>
          <li v-for="page in totalPages" :key="page" class="page-item" :class="{ active: page === currentPage }">
            <button class="page-link" @click="changePage(page)">{{ page }}</button>
          </li>
          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
            <button class="page-link" @click="changePage(currentPage + 1)">Suivant</button>
          </li>
        </ul>
      </div>
    </div>

  </div>
</template>

<script>
import api from '@/api';

export default {
  data() {
    return {
      isLoading: true,
      searchQuery: '',
      itemsperpage: 10,
      orderBy: 'tu.nom',
      sortOrder: 'asc',
      typeUsers: [],
      totalItems: 0,
      currentPage: 1,
      itemsPerPageT: [2,4,6,10],
      orderByTabs: { Nom: 'tu.nom', Création: 'tu.createdAt', Modif: 'tu.updatedAt' },
      sortOrders: { Croissant: 'asc', Décroissant: 'desc' }
    };
  },
  computed: {
    filteredTypeUsers() {
      if (!this.searchQuery) return this.typeUsers;
      const q = this.searchQuery.toLowerCase();
      return this.typeUsers.filter(type => type.nom.toLowerCase().includes(q));
    },
    totalPages() { return Math.ceil(this.totalItems / this.itemsperpage); }
  },
  methods: {
    creation() { this.$router.push({ name: 'create_type_users' }); },
    modifier(id) { 
      console.log(id); 
      this.$router.push({name: 'edit_type_users', params: {id: id}})
    },
    async getTypeUsers() {
      this.isLoading = true;
      try {
        const response = await api.getItems('type_users', { orderBy: this.orderBy, sortOrder: this.sortOrder, itemsperpage: this.itemsperpage, page: this.currentPage });
        const { data, meta } = response.data;
        this.typeUsers = data;
        this.totalItems = meta?.total_records ?? data.length;
      } catch (error) { console.error(error); }
      finally { this.isLoading = false; }
    },
    changePage(page) { if (page > 0 && page <= this.totalPages) { this.currentPage = page; this.getTypeUsers(); } },
    async supprimer(id) {
      if (!confirm("Voulez-vous vraiment supprimer ce rôle ?")) return;
      try { await api.deleteItem('type_users', id); this.getTypeUsers(); } 
      catch { alert("Erreur lors de la suppression."); }
    }
  },
  watch: {
    searchQuery() { this.currentPage = 1; this.getTypeUsers(); },
    itemsperpage() { this.currentPage = 1; this.getTypeUsers(); },
    orderBy() { this.getTypeUsers(); },
    sortOrder() { this.getTypeUsers(); }
  },
  created() { this.getTypeUsers(); }
};
</script>

<style scoped>
.header-clinique { padding: 15px 20px; background-color: #e9f5ff; border-radius: 12px; margin-bottom: 20px; }
.card-clinique { background: #f8fafd; border-radius: 12px; border: none; }
.form-control-clinique, .form-select-clinique { border-radius: 10px; border: 1px solid #d1e3f0; padding: 8px 12px; transition: all 0.3s ease; }
.form-control-clinique:focus, .form-select-clinique:focus { box-shadow: 0 0 6px #0d6efd33; border-color: #0d6efd; }
.btn-clinique { background: linear-gradient(90deg, #0d6efd, #6610f2); border: none; color: #fff; border-radius: 10px; transition: all 0.3s ease; }
.btn-clinique:hover { box-shadow: 0 5px 15px rgba(0,0,0,0.2); transform: translateY(-2px); }
.modern-table-clinique thead { background: linear-gradient(90deg, #8fd3f4, #0d6efd); color: #fff; font-weight: 600; }
.modern-table-clinique tbody tr:hover { background-color: #e1f0ff; cursor: pointer; transition: all 0.3s ease; }
.pagination-modern .page-link { border-radius: 50% !important; margin: 0 4px; min-width: 38px; min-height: 38px; display: flex; align-items: center; justify-content: center; color: #0d6efd; border: 1px solid #dee2e6; }
.pagination-modern .page-item.active .page-link { background-color: #0d6efd; color: #fff; border-color: #0d6efd; }
.pagination-modern .page-link:hover { background-color: #d1e7ff; transition: all 0.3s ease; }
</style>
